/**
 * Constants definition.
 *
 * @type {{NEW: string, REVIEW: string, SIGNATURE_READY: string, SIGNED: string, ANNULLED: string, DEBT_PENDING: string,
 * PENDING: string}}
 */
const CONTRACT_STATUS = {
  NEW: 'NEW',
  REVIEW: 'REVIEW',
  SIGNATURE_READY: 'SIGNATURE_READY',
  SIGNED: 'SIGNED',
  ANNULLED: 'ANNULLED',
  DEBT_PENDING: 'DEBT_PENDING',
  PENDING: 'PENDING',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const CONTRACT_STATUS_ENUM = Object.keys(CONTRACT_STATUS);

const NEW = CONTRACT_STATUS_ENUM[0];
const REVIEW = CONTRACT_STATUS_ENUM[1];
const SIGNATURE_READY = CONTRACT_STATUS_ENUM[2];
const SIGNED = CONTRACT_STATUS_ENUM[3];
const ANNULLED = CONTRACT_STATUS_ENUM[4];
const DEBT_PENDING = CONTRACT_STATUS_ENUM[5];
const PENDING = CONTRACT_STATUS_ENUM[6];

export {
  NEW,
  REVIEW,
  SIGNATURE_READY,
  SIGNED,
  ANNULLED,
  CONTRACT_STATUS_ENUM,
  CONTRACT_STATUS,
  DEBT_PENDING,
  PENDING,
};
